export default "__VITE_ASSET__Dm49Le43__"